import { Globals } from '../../../modules/Globals';
import axios from 'axios';
import { IInvoicingAttemptState } from '@/interfaces/IInvoicingAttempt';

const apiUrl = Globals.apiPath + '/invoicing';

export default class InvoicingAttemptService {
  constructor() {}

  static async getAttempt(publicId: string): Promise<IInvoicingAttemptState> {
    const res = await axios.get<IInvoicingAttemptState>(
      `${apiUrl}/attempts/${publicId}`
    );
    return res.data;
  }
}
